// src/components/homepage/HeroSection.js
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

function HeroSection() {
  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-slate-900 text-white">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-500/60 to-transparent" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-800/80 px-3 py-1 text-xs font-medium uppercase tracking-wide text-slate-300">
          Live incident response for revenue systems
        </span>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight">
          Revenue stopped? Get your payment system fixed in{" "}
          <span className="text-blue-400">under 2 hours.</span>
        </h1>

        <p className="text-lg sm:text-xl md:text-2xl text-slate-300 mb-10 max-w-3xl mx-auto leading-relaxed">
          Live video diagnostic &amp; fix with a vetted Stripe &amp; e-commerce engineer.
          {" "}<span className="text-white font-semibold">Fixed or 100% refunded.</span>
        </p>

        <div className="flex justify-center mb-6">
          <Link
            to="/submit-problem"
            className="group w-full sm:w-auto px-8 py-4 bg-blue-600 text-white font-bold text-lg rounded-xl hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
          >
            <Zap className="w-5 h-5" />
            Request Emergency Fix — from €149
          </Link>
        </div>

        <p className="text-sm sm:text-base text-slate-400">
          Expert on screen within 120 mins max  ·  Mon–Sat 07:00–23:00 CET
        </p>
      </div>
    </section>
  );
}

export default HeroSection;
